module.exports = "<div fxLayout=\"row\" fxLayoutGap=\"20px\" fxLayoutAlign=\"start center\" class=\"item-menu\"\r\n  [ngClass]=\"{'active' : model.isActive, 'last-item': isLast}\" (click)=\"redirect()\" \r\n  [matTooltip]=\"stripTags(model.text)\" matTooltipPosition=\"right\">\r\n  <!-- <div class=\"animation\"></div> -->\r\n  <img [src]=\"model.isActive ? model.iconActive : model.iconInactive\">\r\n  <span *ngIf=\"opened\" [innerHTML]=\"model.text\"></span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/app/components/item-menu/item-menu.component.html
// module id = ../../../../../src/app/components/item-menu/item-menu.component.html
// module chunks = main